// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1ZLkU","label":"Radio_label__2Rto3","checkMark":"Radio_checkMark__m0S5O","disabled":"Radio_disabled__27u7B"};